<template>
  <div class="contents4">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <p class="text1">
        정비사 실명제<br />
        카수리에<br />
        안심하고 맡겨주세요!<br />
      </p>
      <p class="text2">
        3년 이상의 정비경력을 보유한 <br v-if="isMobile" />전문 정비사가<br v-if="!isMobile" />
        고객님이 요청한 장소에 <br v-if="isMobile" />직접 찾아갑니다.<br v-if="!isMobile" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents4.png',
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents4.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents4.png'
        this.isMobile = true
      }
    },
  },
}
</script>

<style scoped>
.contents4 {
  width: 100%;
  position: relative;
}
.contents4 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 28px;
    line-height: 42px;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 23px;
    color: #444444;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.2vw;
    line-height: 3.2vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    line-height: 1.8vw;
    color: #444444;
  }
}
@media (min-width: 641px) {
  .contents4 .contents {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding: 8% 20% 0 0;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents4 .contents {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 6vw;
    color: #444444;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents4.vue